export const APP_NAME = 'Neartix AI'

export const ROUTES = {
  DASHBOARD: '/',
  DIGITAL_QR: '/digital-qr',
  GOOGLE_AUTOMATION: '/google-automation',
  GOOGLE_AUDIT: '/google-audit-report',
  AI_POSTS: '/ai-suggested-posts',
  WEBSITE: '/website',
  NEED_HELP: '/need-help',
  SETTINGS: '/settings',

  // Google Automation sub-pages
  GMB_AI_AGENT: '/google-automation/ai-agent',
  GMB_OPTIMIZATION: '/google-automation/optimization',
  GMB_REVIEWS: '/google-automation/reviews',
  GMB_SCHEDULE: '/google-automation/schedule',
  GMB_POSTS: '/google-automation/posts',
  GMB_CREATE_POST: '/google-automation/posts/create',
  GMB_MEDIA: '/google-automation/media',
  GMB_KEYWORDS: '/google-automation/keywords',
  GMB_PERFORMANCE: '/google-automation/performance',
  GMB_AI_LISTING: '/google-automation/ai-listing',
} as const

export const GMB_BASE = ROUTES.GOOGLE_AUTOMATION
